import React, { useEffect, useMemo, useState } from "react"
import { useDataSource } from "../../../../../contexts/dataSource"
import { getPropsDataGrid, getPropsLookupExprForIdText } from "../../../../../utils/default-props"
import { useNavigate } from "react-router-dom"
import { DataGrid } from "devextreme-react"
import { Column, Editing, Lookup, Toolbar } from "devextreme-react/cjs/data-grid"
import { usePublicEvents } from "../../../../../contexts/public-events"
import { getDataGridCustomToolbarCaption } from "../../../../../components/default-components/data-grid-custom-toolbar"
import { useLookupGroup } from "../../../../../contexts/lookup-group-context"
import { useAuth } from "../../../../../contexts/auth"
import { lookupGroups } from "../../../../../utils/lookup-groups.ts"



function ApproveHierarchyList() {
    const [id, setId] = useState()
    const { dataSourceHR } = useDataSource()
    const navigate = useNavigate();
    const { setPublicAddEvent } = usePublicEvents()
    const [approveHierarchyTypes, setApproveHierarchyTypes] = useState([]);

    const { getLookupData } = useLookupGroup()
    const { activeLanguage } = useAuth()

    const dataSource = useMemo(() => dataSourceHR({
        loadUrl: "/api/ApproveHierarchy",
        insertUrl: "/api/ApproveHierarchy/FormData",
    }), [dataSourceHR])

    const handleFocusedRowChange = (e) => {
        setId(e.component.option('focusedRowKey'));
    }

    const handleRowDblClick = (e) => {
        if (id) navigate(`/approve-hierarchy-list/approve-hierarchy-card/${id}`)
    }

    const approveHierarchyTypeEditorOption = useMemo(() => (
        {
            ...getPropsLookupExprForIdText,
            dataSource: approveHierarchyTypes,
            //onValueChanged: (e) => { setSelectedLeaveType(e.value) }
        }), [approveHierarchyTypes]
    )

    useEffect(() => {
        getLookupData(lookupGroups.approveHierarchyTypes).then(response => setApproveHierarchyTypes(response))
    }, [activeLanguage, getLookupData])

    useEffect(() => {

        if (setPublicAddEvent)
            setPublicAddEvent(() => {
                return () => { navigate('/approve-hierarchy-list/approve-hierarchy-card') }
            })

        return () => {
            if (setPublicAddEvent)
                setPublicAddEvent(undefined)
        }

    }, [setPublicAddEvent, navigate])

    return (
        <React.Fragment>
            <div className={'content-block'}>
                <div className={'dx-card responsive-paddings'}>

                    <DataGrid
                        {...getPropsDataGrid}
                        dataSource={dataSource}
                        focusedRowKey={id}
                        onFocusedRowChanged={handleFocusedRowChange}
                        onRowDblClick={handleRowDblClick}
                        remoteOperations={false}
                        showRowLines={false}
                        height="70vh"
                        width={450}
                    >
                        <Editing
                            allowDeleting={true}
                        />
                        <Toolbar>
                            {getDataGridCustomToolbarCaption("Onay Hiyerarşi Listesi")}
                        </Toolbar>

                        <Column dataField="name" caption="Onay Hiyerarşi Tanımı" />
                        <Column dataField="approveHierarchyTypeId" caption="Hiyerarşi Türü" >
                            <Lookup dataSource={approveHierarchyTypes} {...getPropsLookupExprForIdText} />
                        </Column>
                        

                    </DataGrid>
                </div>
            </div>
        </React.Fragment>


    )
}


export default ApproveHierarchyList